<template>
  <div class="league-game-container">
    <el-form label-width="96px">
      <el-form-item label="选择联赛">
        <el-select v-model="match" filterable value-key="name" placeholder="请选择" @change="selectMatch" >
          <el-option
            v-for="item in matchList"
            :key="item.id"
            :label="item.name"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择组别">
        <el-select v-model="group" filterable value-key="name" placeholder="请选择" @change="selectGroup" >
          <el-option
            v-for="item in groupList"
            :key="item.id"
            :label="item.name"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择周次">
        <el-select v-model="week" filterable value-key="name" placeholder="请选择" @change="selectWeek" >
          <el-option
            v-for="item in weekList"
            :key="item.id"
            :label="item.name"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择阶段">
        <el-select v-model="stage" filterable value-key="name" placeholder="请选择" @change="selectStage" >
          <el-option
            v-for="item in stageList"
            :key="item.id"
            :label="item.name"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="比赛场次">
        <el-input v-model="seq" ></el-input>
      </el-form-item>
      <el-form-item label="历史操作" >
        <el-button @click="getGameList" :disabled="!groupId">查询</el-button>
        <el-dropdown @command="routerTeamPlayer" >
          <span class="el-dropdown-link">
            比赛操作历史<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in historyList" :key="item.id" :command="item.id" >{{ item.homeTeamName }} VS {{ item.awayTeamName }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-form-item>
    </el-form>
    <el-table
      v-loading="listLoading"
      :data="gameList"
      style="width: 100%">
      <el-table-column
        label="场次"
        width="60"
        prop="seq">
      </el-table-column>
      <el-table-column
        :formatter="formatDate"
        width="180"
        prop="beginDate">
        <template slot="header" slot-scope="scope">
          <div>比赛时间</div>
          <el-date-picker
            v-model="search.beginDate"
            @change="getGameList"
            type="date"
            placeholder="选择日期" />
        </template>
      </el-table-column>
      <el-table-column
        prop="homeTeamName">
        <template slot="header" slot-scope="scope">
          <div>主队</div>
          <el-input v-model="search.homeTeamName" @change="getGameList" placeholder="关键字" ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="awayTeamName">
        <template slot="header" slot-scope="scope">
          <div>客队</div>
          <el-input v-model="search.awayTeamName" @change="getGameList" placeholder="关键字" ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="比分">
        <template slot-scope="scope" >
          {{ scope.row.homeScore<0?'-':scope.row.homeScore}} : {{ scope.row.awayScore<0?'-':scope.row.awayScore }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="250"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="GetGame(scope.row.id)">编辑</el-button>
          <el-button
            size="mini"
            @click="goScores(scope.row.id)">成绩录入</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDeleteGame(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!-- 更新赛事 -->
    <el-dialog
      :visible.sync="updateMatchDialogVisible"
      title="更新比赛信息"
      width="50%">
      <div>
        <el-form class="match-dialog-visible" label-width="96px" >
          <el-form-item label="选择周次" >
            <el-select v-model="updateMatch.week" filterable value-key="name" placeholder="请选择">
              <el-option
                v-for="item in weekList"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择阶段" >
            <el-select v-model="updateMatch.stage" filterable value-key="name" placeholder="请选择">
              <el-option
                v-for="item in stageList"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="比赛场地" >
            <el-row>
              <el-input v-model="updateMatch.venue"></el-input>
            </el-row>
          </el-form-item>
          <el-form-item class="match-date" label="比赛时间" >
            <el-date-picker
              v-model="updateMatch.beginDate"
              type="datetime"
              placeholder="选择开始日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="比赛场次" >
            <el-row>
              <el-input v-model="updateMatch.seq"></el-input>
            </el-row>
          </el-form-item>
          <el-form-item label="加场" >
            <el-row>
              <el-input v-model="updateMatch.add"></el-input>
            </el-row>
          </el-form-item>
          <el-form-item label="选择主队" >
            <el-select v-model="updateMatch.homeTeam" filterable value-key="name" placeholder="请选择">
              <el-option
                v-for="item in teamList"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择客队" >
            <el-select v-model="updateMatch.awayTeam" filterable value-key="name" placeholder="请选择">
              <el-option
                v-for="item in teamList"
                :key="item.id"
                :label="item.name"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateMatchDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateGame">确 定</el-button>
      </span>
    </el-dialog>
    <!-- create/edit modal start -->
  </div>
</template>

<script>
import moment from 'moment'
import find from 'lodash/find'
import { getMatchList, getMatchGroupList, getMatchGroupTeamList, auditStatus, createTeamStatus, getGroupStageList,
  updateTeam, getGameList, getGroupWeekList, deleteGame, GetGame, updateGame } from '@/api/match'
export default {
  name: 'LeagueGameList',
  data() {
    return {
      match: {},
      matchId: null,
      matchList: [],
      listLoading: false,
      group: {},
      groupId: null,
      groupList: [],
      gameList: [],
      search: {},
      totalCount: 0, // 默认数据总数
      pageSize: 20, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      auditStateList: [],
      historyList: [],
      stage: null,
      stageList: [],
      weekId: null,
      week: null,
      weekList: [],
      matchNumber: null,
      seq: null,
      beginDate: null,
      homeTeamName: null,
      awayTeamName: null,
      updateMatchDialogVisible: false,
      updateMatch: {
        week: null,
        stage: null,
        venue: null,
        beginDate: null,
        endDate: null,
        seq: null,
        homeTeam: null,
        awayTeam: null
      },
      teamList: []
    }
  },
  created() {
    this.getMatchList()
    this.getHistoricalOperation()
  },
  computed: {
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.getGameList()
    },
    getMatchList() {
      const params = {
        status: 0,
        pageSize: 9999
      }
      getMatchList(params).then((resolve) => {
        this.matchList = resolve.data.list
      })
    },
    selectMatch(item) {
      getMatchGroupList({ matchId: item.id, pageSize: 9999 }).then((resolve) => {
        this.groupList = resolve.data.list
      })
      this.matchId = item.id
      this.groupId = ''
    },
    selectGroup(item) {
      this.groupId = item.id
      this.getGroupWeekList()
      this.getGroupStageList()
      this.getMatchGroupTeamList()
      this.getGameList()
    },
    selectWeek(item) {
      this.weekId = item.id
      this.getGameList()
    },
    selectStage(item) {
      this.stageId = item.id
      this.getGameList()
    },
//    getList() {
//      this.listLoading = true
//      this.listQuery = {
//        groupId: this.groupId,
//        weekId: this.weekId,
//        stageId: this.stageId,
//        seq: this.seq,
//        beginDate: this.beginDate,
//        homeTeamName: this.homeTeamName,
//        awayTeamName: this.awayTeamName,
//        history: 0,
//        pageNum: this.currentPage,
//        pageSize: this.pageSize,
//      }
//      getGameList(this.listQuery).then(response => {
//        const data = response.data
//        this.matchList = data.list
//        this.currentPage = data.pageNum
//        this.totalCount = data.count
//        this.listLoading = false
//      })
//    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getGameList()
    },
    quickSearch() {
      this.getGameList()
    },
    getGameList() {
      if (!this.groupId) return
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        groupId: this.groupId,
        stageId: this.stageId,
        weekId: this.weekId,
        seq: this.seq
      }
      if (this.search.beginDate) {
        this.search.beginDate = moment(this.search.beginDate).format('YYYY-MM-DD')
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      getGameList(this.listQuery).then((resolve) => {
        const data = resolve.data
        this.listLoading = false
        if(data) {
          this.gameList = data.list
          this.currentPage = data.pageNum
          this.totalCount = data.count
        }
      })
    },
    formatDate: function(row, column) {
      const date = row[column.property]
      return date && moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    routerTeamPlayer(id) {
      this.$router.push({
        name: 'LeagueGroupGameScore',
        params: {
          id: this.matchId,
          gid: this.groupId,
          mid: id
        }
      })
    },
    getGroupStageList() { // 获取阶级
      getGroupStageList({ groupId: this.groupId, pageSize: 9999 }).then((resolve) => {
        this.stageList = resolve.data.list
      })
    },
    getHistoricalOperation() {
      let params = {
        history: 1
      }
      getGameList(params).then((resolve) => {
        if (resolve) {
          const data = resolve.data
          this.historyList = data.list
        }
      })
    },
    getGroupWeekList() {
      getGroupWeekList({ groupId: this.groupId, pageSize: 9999 }).then((resolve) => {
        if (resolve) {
          this.weekList = resolve.data.list
        }
      })
    },
    deleteGame(id) {
      deleteGame({ id: id }).then((resolve) => {
        if (resolve) {
          this.$message({
            message: '删除成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getGameList()
        }
      })
    },
    getMatchGroupTeamList() {
      getMatchGroupTeamList({ groupId: this.groupId, pageSize: 999 }).then((resolve) => {
        this.teamList = resolve.data.list
      })
    },
    goScores(gameId) {
      this.$router.push({ name: 'LeagueGroupGameScore', params: { id: this.matchId, gid: this.groupId, mid: gameId }})
    },
    GetGame(id) {
      this.updateMatchDialogVisible = true
      GetGame({ id: id }).then((resolve) => {
        let game = resolve.data.game
        this.updateMatch.venue = game.venue
        this.updateMatch.seq = game.seq
        this.updateMatch.beginDate = game.beginDate
        this.updateMatch.endDate = game.endDate
        this.updateMatch.id = id
        this.weekList.filter((item) => {
          if (game.weekId === item.id) {
            this.updateMatch.week = item
          }
        })
        this.stageList.filter((item) => {
          if (game.stageId === item.id) {
            this.updateMatch.stage = item
          }
        })
        this.teamList.filter((item) => {
          if (game.homeTeamId === item.id) {
            this.updateMatch.homeTeam = item
          } else if (game.awayTeamId === item.id) {
            this.updateMatch.awayTeam = item
          }
        })
      })
    },
    updateGame() {
      let params = {
        id: this.updateMatch.id,
        stageId: this.updateMatch.stage.id,
        weekId: this.updateMatch.week.id,
        venue: this.updateMatch.venue,
        seq: this.updateMatch.seq,
        homeTeamId: this.updateMatch.homeTeam.id,
        awayTeamId: this.updateMatch.awayTeam.id
      }
      if (this.updateMatch.beginDate) {
        params.beginDate = moment(this.updateMatch.beginDate).format('YYYY-MM-DDTHH:mm:ss+0800')
      }
      updateGame(params).then((resolve) => {
        if (resolve && resolve.data) {
          this.updateMatchDialogVisible = false
          this.$message({
            message: '比赛更新成功',
            type: 'success'
          })
          this.getGameList()
        }
      })
    },
    handleDeleteGame(id) {
      this.$confirm('此操作将永久删除该比赛, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteGame(id)
      }).catch(() => {
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .league-game-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }

    .el-date-editor.el-input {
      width: 140px;
    }

    .el-input__prefix {
      left: 10px
    }

    .el-input__suffix {
      right: 10px;
    }

    .el-input--prefix .el-input__inner {
      padding-left: 25px;
      padding-right: 20px;
    }

    .demonstration {
      display: block;
      padding-bottom: 15px;
    }

    .input-win {
      width: 200px !important;
    }

    .input-win .el-input__prefix {
      left: 5px;
    }

    .el-form {
      .el-input {
        width: auto;
      }
    }

    .active {
      color: #fff;
      background-color: #67c23a;
      border-color: #67c23a;
    }

  }
</style>
